import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import './Auth.scss';

export class Auth extends Component {

    state = {
        cancel: false,
        username: '',
        psd: ''
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            ...this.state,
            [name]: value
        })
    }

    handleSubmit = () => {
        const { username, psd } = this.state;
        if (username===import.meta.env.VITE_USERNAME && psd===import.meta.env.VITE_PASSWORD) {
            this.props.authenticate();
            sessionStorage.setItem('isVerified', true);
        } else {
            window.location.reload();
        }
    }

    cancel = () => {
        this.setState({
            ...this.state,
            cancel: true
        })
    }

    render() {
        const envprop = import.meta.env.VITE_ENVIRONMENT ? import.meta.env.VITE_ENVIRONMENT.toLowerCase()+'.' : '';
        return (
            <div>
                {!this.state.cancel ? 
                <div id="alert">
                    <h3>Sign in</h3>
                    <p>{`https://${envprop}expertcommunicationpreferences.com`}</p>
                    <form name="alert-form" action="#" method="#">
                    <div className="flex">
                        <label htmlFor="username" className="labels" id="userlbl" value={this.state.username}>Username</label>
                        <input type="text" name="username" className="inputbox" id="user" value={this.state.username} data-testid="input-username" onChange={e=>this.handleChange(e)}/>
                        <span id='user_msg'></span>
                    </div>
                    <div className="flex">
                        <label htmlFor="psd" className="labels" id="passlbl">Password</label>
                        <input type="password" name="psd" className="inputbox" id="pwd" value={this.state.password} data-testid="input-password" onChange={e=>this.handleChange(e)}/>
                        <span id='password_msg'></span>
                    </div>
                    <div className="buttons">
                        <button type="button" className="signin" id="loginAuth" data-testid="sign-in" onClick={this.handleSubmit}>Sign in</button>
                        <button type="button" className="cancel" id="cancelAuth" data-testid="cancel-button" onClick={this.cancel}>Cancel</button>
                    </div>
                    </form>
                </div>
                : <div id="cancelBlock">
                    <h3>Unauthorised</h3>
                    <p>This server could not verify that you are authorized to access the document requested. Either you supplied the wrong credentials (e.g., bad password), or your browser doesn&apos;t understand how to supply the credentials required.</p>
                </div>
                }
            </div>
        )
    }
}

export default withTranslation()(Auth);
